// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Cn from "../../../../node_modules/rescript-classnames/lib/es6_global/src/Cn.bs.js";
import * as Curry from "../../../../node_modules/rescript/lib/es6/curry.js";
import * as React from "react";
import * as Belt_Option from "../../../../node_modules/rescript/lib/es6/belt_Option.js";
import * as Caml_option from "../../../../node_modules/rescript/lib/es6/caml_option.js";
import * as CSS$Showside from "../utils/CSS.bs.js";
import * as Webapi__Dom__Element from "../../../../node_modules/rescript-webapi/lib/es6_global/src/Webapi/Dom/Webapi__Dom__Element.bs.js";
import * as DataAttribute$Showside from "../utils/DataAttribute.bs.js";
import * as ReactDOMUtils$Showside from "../utils/ReactDOMUtils.bs.js";
function CollapsibleText(Props) {
  var maxLinesOpt = Props.maxLines;
  var className = Props.className;
  var readMoreLabelOpt = Props.readMoreLabel;
  var readMoreAriaLabelOpt = Props.readMoreAriaLabel;
  var readLessLabelOpt = Props.readLessLabel;
  var readLessAriaLabelOpt = Props.readLessAriaLabel;
  var buttonDataTestId = Props.buttonDataTestId;
  var contentDataTestId = Props.contentDataTestId;
  var children = Props.children;
  var maxLines = maxLinesOpt !== undefined ? maxLinesOpt : 3;
  var readMoreLabel = readMoreLabelOpt !== undefined ? readMoreLabelOpt : "Read More";
  var readMoreAriaLabel = readMoreAriaLabelOpt !== undefined ? readMoreAriaLabelOpt : "Expand the text to read more";
  var readLessLabel = readLessLabelOpt !== undefined ? readLessLabelOpt : "Read Less";
  var readLessAriaLabel = readLessAriaLabelOpt !== undefined ? readLessAriaLabelOpt : "Collapse the text to read less";
  var match = React.useState(function () {
    return false;
  });
  var setIsExpanded = match[1];
  var isExpanded = match[0];
  var match$1 = React.useState(function () {
    return false;
  });
  var setShowButton = match$1[1];
  var textRef = React.useRef(null);
  var checkOverflow = function (param) {
    var element = Belt_Option.flatMap(Caml_option.nullable_to_opt(textRef.current), Webapi__Dom__Element.asHtmlElement);
    if (element === undefined) {
      return;
    }
    var element$1 = Caml_option.valFromOption(element);
    var offsetHeight = element$1.offsetHeight;
    var scrollHeight = element$1.scrollHeight;
    Curry._1(setShowButton, function (param) {
      return scrollHeight > offsetHeight;
    });
  };
  React.useLayoutEffect(function () {
    checkOverflow(undefined);
    var listener = function (param) {
      checkOverflow(undefined);
    };
    window.addEventListener("resize", listener);
    return function (param) {
      window.removeEventListener("resize", listener);
    };
  });
  var tmp = {
    children: React.createElement("div", {
      ref: ReactDOMUtils$Showside.Ref.domRef(textRef),
      className: CSS$Showside.prefix(Cn.make(["inline", "overflow-hidden", isExpanded ? "" : CSS$Showside.lineClampOfInt(maxLines)]))
    }, children)
  };
  if (contentDataTestId !== undefined) {
    tmp.dataTestId = Caml_option.valFromOption(contentDataTestId);
  }
  var tmp$1;
  if (match$1[0]) {
    var tmp$2 = {
      children: React.createElement("div", {
        "aria-label": isExpanded ? readLessAriaLabel : readMoreAriaLabel,
        className: CSS$Showside.prefix(Cn.make(["text-accent", "font-semibold", "inline", isExpanded ? "ml-4" : "absolute bottom-0 right-0 bg-main pl-4", "cursor-pointer"])),
        tabIndex: 0,
        onClick: function (param) {
          Curry._1(setIsExpanded, function (x) {
            return !x;
          });
        }
      }, isExpanded ? readLessLabel : readMoreLabel)
    };
    if (buttonDataTestId !== undefined) {
      tmp$2.dataTestId = Caml_option.valFromOption(buttonDataTestId);
    }
    tmp$1 = React.createElement(DataAttribute$Showside.make, tmp$2);
  } else {
    tmp$1 = null;
  }
  return React.createElement("div", {
    "aria-expanded": isExpanded,
    className: Cn.make([CSS$Showside.prefix("relative"), Belt_Option.getWithDefault(className, "")])
  }, React.createElement(DataAttribute$Showside.make, tmp), tmp$1);
}
CollapsibleText.displayName = "CollapsibleText";
var make = CollapsibleText;
export { make };
/* react Not a pure module */